import React from 'react'
import List, {
  ListItem,
  ListItemText,
  ListSubheader,
  ListItemIcon
} from 'material-ui/List'

import { formatAddress } from './utils'
import StopIcons from './StatusIcon'

const StopList = ({stops, openManifest}) => {
  return <List subheader={<ListSubheader>Stops</ListSubheader>}>
    {stops.map(stop =>
      <ListItem onClick={() => openManifest(stop.jobId, stop._id)} button key={stop._id}>
        <ListItemIcon>
          <StopIcons status={stop.status} />
        </ListItemIcon>
        <ListItemText
          title={stop._id}
          primary={formatAddress(stop.address)}
        />
      </ListItem>
    )}
  </List>
}

export default StopList



// WEBPACK FOOTER //
// ./src/jobs/StopList.js